import { React, useRef, useState } from 'react'
import { Container, Row, Col, Form, Button, InputGroup, OverlayTrigger, Tooltip,  Modal} from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import ServicesRequest from '../../../service/ServiceRequest'
import ReactLoading from "react-loading";
import Swal from 'sweetalert2'
import { PublicStrings } from '../../../constants/Public-Strings'
import { CampaignString } from '../../../constants/Campaign-Strings'
import { successToast } from '../../../constants/Toasts-Components'




const EnabledUsersOrAgenciesList = ({ enabled_for, campaign_id, setEnabledFor}) => {

    const { config } = useSelector((state) => state.auth);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [subordinates, setSubordinates] = useState([]);
    let serviceRequestObj = new ServicesRequest("campaign");

    const [all_products, setAllProducts] = useState([]);
    async function fetchAgencies(){
        let agencyServiceRequestObj = new ServicesRequest("agency");
        const response = await agencyServiceRequestObj.getProductListComplete();
        if(response && response.data){
            setAllProducts(response.data);
            console.log("agencies: ")
            console.log(response.data)
        }
    }
    useEffect(() => {
        fetchAgencies();
    }, [])

    return (
        <>        
            <Card className="smooth-transition">
                <Card.Body>

                    <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                        
                        <div className="d-flex align-items-center justify-content-between">
                            <h5 className="font-weight-bold">Campagne abilitate per agenzie e utenti</h5>
                        </div>

                        <Button variant="primary" onClick={handleShow}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            Aggiungi
                        </Button>
                
                        <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Abilita Campagna Per:</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                        <table className="table data-table mb-0">
                            <tbody>
                                {
                                        <>
                                            {
                                               enabled_for.length === all_products.length ? 
                                    
                                               <i> Questa campagna è già abilitata per tutti gli utenti </i>
                                                : 

                                                all_products.map((item, index) => ( 
                                                    
                                                    enabled_for.map(user  => user.pk).includes(item.id) ? "" :
                                                        <tr className="white-space-no-wrap" key={index}>

                                                            <td style={{"padding" : "0px" , "borderTop" : "1px"}}>
                                                                <div className="d-flex justify-content-end align-items-center">

                                                                        <button type="button" className="dropdown-item bg-light border rounded btn-block mb-2" onClick={async () => {
                                                                            
                                                                            const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(campaign_id, item.id, 'agency', true, 'campaign')
                                                                            if(response !== null){
                                                                                if(response.response){

                                                                                    Swal.fire({
                                                                                        icon: 'error',
                                                                                        title: 'Error',
                                                                                        text: response.response.data.error_message,
                                                                                    })
                                                                                } else{
                                                                                    console.log("Adding stuff");
                                                                                    handleClose();
                                                                                    console.log(enabled_for);
                                                                                    setEnabledFor(values => ([ ...values, item ]))
                                                                                }  
                                                                            }

                                                                        }}>
                                                                            

                                                                            {item.name}
                                                                        </button>
                                 

                                                                </div>
                                                            </td>
                                                         </tr>
                                                    

                                                ))
                                            }
                                        </>
                                }
                            </tbody>
                        </table>

                        </Modal.Body>
                        
                        </Modal>

                    </div>

                    
                    
                                
                                <>
                                {
                                    enabled_for.length === 0 ? 

                                        <i> Questa campagna non è abilitata per nessun utente </i>
                                    :<table className="table data-table mb-0">
                                    <tbody>
                                          
                                        {enabled_for.map((item, index) => ( 
                                            
                                            <tr id={"enabled_row_"+item.id} key={index} className="white-space-no-wrap">

                                                <td> {item.name}</td>

                                                <td>
                                                    <div className="d-flex justify-content-end align-items-center">

                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Remove</Tooltip>} >
                                                            <h6 className="badge bg-danger" onClick={async () => {

                                                                const response = await serviceRequestObj.toggleEnableProductForUserOrAgency(campaign_id, item.id, 'agency', false, 'campaign')
                                                                if(response !== null){
                                                                    if(response.response){

                                                                        Swal.fire({
                                                                            icon: 'error',
                                                                            title: 'Error',
                                                                            text: response.response.data.error_message,
                                                                        })
                                                                    } else{
                                                                        console.log("Deleting stuff");
                                                                        setEnabledFor(values => (values.filter(f => f.id !== item.id)));
                                                                        var row = document.getElementById(`enabled_row_${item.id}`);
                                                                        row.remove();
                                                                    }  
                                                                }

                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                </svg>
                                                            </h6>
                                                        </OverlayTrigger>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                        
                                    
                                }
                                </>
                            
                            
                        

                </Card.Body>
            </Card>

        </>
    )
}


const CampaignAddOrView = (props) => {

    let serviceRequestObj = new ServicesRequest("campaign");


    const form = useRef(null);
    const { config } = useSelector((state) => state.auth)

    const [inputs, setInputs] = useState({

        name : '',
        product : '',
        opening_date : new Date().toISOString().split('T')[0],
        closing_date : null,
        commission:100,
        
        
    });

    const [productList, setProductList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [is_renewable, setIsRenewable] = useState(false);
    const [enabled_for, setEnabledFor] = useState([]);


    const [is_new_product, setIsNewProduct] = useState(true)
    const [campaign_id, setCampaignId] = useState("");

    const params = useParams();

    async function fetchCampaignInfo(campaign_id) {

        setLoading(true);

        const response = await serviceRequestObj.getProductInfo(campaign_id);
        if (!response.response) {
            console.log(response)
            setProductList(response.all_products)
            setEnabledFor(response.data.enabled_for || []);

            

            const columns = ['id', 'name', 'product', 'commission', 'opening_date', 'closing_date']

            for (const key of columns) {
                var value = response.data[key];
                if (value !== null) {
                    if(key === "product"){

                        if(config.is_admin){

                            setInputs(values => ({ ...values, [key]: value.id }))
                        }else{
                            setInputs(values => ({ ...values, [key]: value.name }))

                        }
                    }
                    else{
                        setInputs(values => ({ ...values, [key]: value }))

                    }
                }
            }
            
        }
        setLoading(false);
    }

    async function fetchAllProducts(){
        var RequestService = new ServicesRequest("product");
        const response =await RequestService.getProductListComplete();
        console.log(response)
        if(!response.response){
            console.log(response)
            setProductList(response.data)
        }
    }


    useEffect(() => {

        //console.log("Product id: "+params.campaign_id + " ", isNaN(params.campaign_id), params.campaign_id === null)
        setCampaignId(params.campaign_id);
        setIsNewProduct(isNaN(params.campaign_id));

        if (params.campaign_id) {
            fetchCampaignInfo(params.campaign_id);
            
        }else{
            fetchAllProducts();
        }

    }, [])




    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }))
    }


    const handleSwitchChange = (event) => {

        const name = event.target.name;
        const value = event.target.checked;
        setInputs(values => ({ ...values, [name]: value }))
    }

    

    const submitCreateProduct = async (event) => {

        event.preventDefault();
        setLoading(true);
        const response = await serviceRequestObj.createProduct(inputs);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            setCampaignId(response.id);
            setIsNewProduct(false);
            setInputs(values => ({ ...values, "id": response.id }))
            setEnabledFor(response.enabled_for || [])
            const editUrl = "/campaign-view/" + response.id;
            window.history.replaceState(null, "", editUrl);
            successToast('Campaign Added Successfully..')
        }
        setLoading(false)
        
    }


    const submitSaveProduct = async (event) => {
        event.preventDefault();
        setLoading(true);
        console.log(inputs)
        // setInputs(values => ({ ...values, id: campaign_id }))
        
        const response = await serviceRequestObj.saveProduct(inputs);
        if (response.response) {

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.response.data.error_message,
            })

        } else {
            successToast('Update Successfully..')
        }
        setLoading(false)
    }


    return (
        <>
            <Container fluid className='smooth-transition'>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb p-0 mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={{ pathname: "/campaign", state: {}}}> {CampaignString.title} </Link>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page">{is_new_product ? CampaignString.addCampaign : (config.is_admin? CampaignString.editCampaign : CampaignString.viewCampaign) }</li>
                                    </ol>
                                </nav>
                            </div>
                            <Link to={{ pathname: "/campaign", state: {}}} className="btn btn-primary btn-sm d-flex align-items-center justify-content-between ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                </svg>
                                <span className="ml-2">{PublicStrings.back}</span>
                            </Link>
                        </div>
                    </Col>
                    <Col lg="12" className="mb-3 d-flex justify-content-between">
                        <h4 className="font-weight-bold d-flex align-items-center">{is_new_product ? CampaignString.addCampaign : (config.is_admin? CampaignString.editCampaign : CampaignString.viewCampaign)}</h4>
                    </Col>
                    <Col lg="12">
                        <Card>
                            <Card.Body className="smooth-transition">
                                {loading && is_new_product === false ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                                        <ReactLoading
                                            type={"spin"}
                                            color={"#007bff"}
                                            height={50}
                                            width={50}
                                        />
                                    </div>
                                ) : (
                                <Form className=" g-3" onSubmit={is_new_product ? submitCreateProduct : submitSaveProduct} ref={form}>
                                    <div className='row'>

                                        <Form.Control type='text' name='id' value={campaign_id} hidden />

                                        <div className="col-md-6 mb-3" key="1">
                                            <Form.Label htmlFor='name' className="form-label font-weight-bold text-muted text-uppercase">{CampaignString.name}</Form.Label>
                                            <Form.Control type='text' className="form-control" name='name' placeholder=''
                                                maxLength="30"
                                                value={inputs["name"]}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                            
                                        </div>



                                        <div className="col-md-6 mb-3" key="3">
                                            <Form.Label htmlFor='product' className="form-label font-weight-bold text-muted text-uppercase">{CampaignString.product}</Form.Label>
                                            {
                                                config.is_admin ? 
                                            <Form.Group>    
                                            <Form.Control as="select" className="mb-3" name='product' value={is_new_product? inputs['product']:inputs['product']} onChange={handleChange} required>
                                                    {
                                                        is_new_product?
                                                        <option defaultValue="">Select Product</option> :<></>

                                                    }
                                                
                                                    
                                                    
                                                    {
                                                    productList.length > 0 ?
                                                    productList.map((e,index)=>

                                                        <option key={index} value={e.id}>{e.name}</option>
                                                    ):<></>
                                                    }
                                                    
                                                
                                                
                                            </Form.Control>
                                            </Form.Group>:
                                            <Form.Control type='text' className="form-control" name='product' placeholder=''
                                                maxLength="30"
                                                value={inputs['product']}
                                                onChange={(e)=>handleChange(e)}
                                                required
                                                disabled={!config.is_admin}
                                            />
                                            }
                                            
                                        </div>


                                        <div className="col-md-6 mb-3" key="7">
                                            <Form.Label htmlFor='opening_date' className="form-label font-weight-bold text-muted text-uppercase">{CampaignString.opening_date}</Form.Label>
                                            <Form.Control type="date" className="form-control" name='opening_date' placeholder=''
                                                value={inputs[`opening_date`] ? inputs[`opening_date`] : new Date().toISOString().split('T')[0]}
                                                onChange={(e)=>handleChange(e)}
                                                required={true}
                                                disabled={!config.is_admin}
                                            />

                                        </div>


                                        <div className="col-md-6 mb-3" key="8">
                                            <Form.Label htmlFor='closing_date' className="form-label font-weight-bold text-muted text-uppercase">{CampaignString.closing_date}</Form.Label>
                                            <Form.Control type="date" className="form-control" name='closing_date' placeholder=''
                                                value={inputs[`closing_date`] ? inputs[`closing_date`] : ""}
                                                onChange={(e)=>handleChange(e)}
                                                required={false}
                                                disabled={!config.is_admin}
                                            />
                                        </div>


                                        <div className="col-md-4 mb-3" key="4">

                                            <Form.Label htmlFor='commission' className="form-label font-weight-bold text-muted text-uppercase">Rappel sulla Produzione</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text id="basic-addon1">%</InputGroup.Text>
                                                <Form.Control type="number" name='commission' placeholder=''
                                                    value={inputs['commission']} 
                                                    onChange={(e)=>handleChange(e)}
                                                    required={false}
                                                    min={0} max={100}
                                                    disabled={!config.is_admin}
                                                />
                                            </InputGroup>
                                        </div>


                                       

                                    </div>
                                    {   
                                        !config.is_admin ?  "" :
                                            (
                                                loading ? 
                                                    <Button type="button" disabled><ReactLoading
                                                        className="mx-auto"
                                                        type={"spin"}
                                                        color={"#fefefe"}
                                                        height={24}
                                                        width={24}
                                                    /></Button> 
                                                : 
                                                <Button type="submit">{is_new_product ? PublicStrings.add : PublicStrings.save}</Button>
                                            )

                                    }

                                    


                                </Form>
                                )}
                            </Card.Body>
                        </Card>
                        
                        { !config.is_admin ? "" :  
                            <div hidden={is_new_product} className="col-md-6" style={{ "paddingLeft": "0px" }}>
                                <EnabledUsersOrAgenciesList
                                    enabled_for = {enabled_for}
                                    campaign_id = {campaign_id}
                                    setEnabledFor = {setEnabledFor}
                                ></EnabledUsersOrAgenciesList>
                            </div> 
                          
                        }

                        
                    </Col>
                </Row>
            </Container>
        </>
    )
}
export default CampaignAddOrView;